module.exports = __webpack_public_path__ + "img/import-4.27f96aa5.png";